<template>
  <div class="box input-with-button focus-effect" @click="focusInput">
    <div class="input-container">
      <input
        ref="input"
        class="input"
        v-model="internalValue"
        :type="inputType"
        :placeholder="inputPlaceholder"
        @input="onInputChange"
        required
        :disabled="inputDisabled"
      />
    </div>
    <button :disabled="buttonDisabled" :id="buttonId" class="button" type="submit">
      {{ buttonText }}
    </button>
  </div>
</template>

<style lang="scss" scoped>
@import "@/variables.scss";
.input-with-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 1.5rem;
  border-radius: 2rem;
  border: none;
  cursor: text;

  .input-container {
    width: 60%;
  }

  .input {
    width: 100%;
    border: none;
    font-size: 1rem;
    padding-right: 16px;

    &:focus {
      outline: none;
    }

    &:disabled {
      background-color: transparent;
    }
  }
  .button {
    margin: 0;
    border: none;
    // changed css for iframe background: $color-secondary;
    background: #337078;
  }
}
</style>

<script>
export default {
  name: "BisgrafInputWithButton",

  props: {
    value: {
      type: String,
      required: true
    },
    inputType: {
      type: String,
      required: true
    },
    inputPlaceholder: {
      type: String,
      required: true
    },
    inputDisabled: {
      type: Boolean,
      required: false
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonDisabled: {
      type: Boolean,
      required: false
    },
    buttonId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      internalValue: this.value
    };
  },

  methods: {
    onSubmit() {
      if (this.internalValue !== "") {
        this.$emit("button-click");
      }
    },
    focusInput() {
      this.$nextTick(() => this.$refs.input.focus());
    },
    onInputChange() {
      this.$emit("input", this.internalValue);
    }
  },

  watch: {
    value() {
      this.internalValue = this.value;
    }
  }
};
</script>
